import _ from 'lodash';
import {
  FETCH_VOLUMES,
  UPDATE_VOLUME,
  DELETE_VOLUME,
  CREATE_VOLUME,
} from './types';
import { setErrorMessage } from './errorMessage';
import api from '../apis/api';
import getMessageFromApiError from '../util/getMessageFromApiError';

export const fetchVolumes = (project_uuid) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    let res = await api.get('/volume', { params: { project_uuid } });
    dispatch({
      type: FETCH_VOLUMES,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const updateVolume = (project_uuid, id, name) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.patch(
      `/volume/${id}`,
      { name: name },
      { params: { project_uuid } }
    );
    dispatch({
      type: UPDATE_VOLUME,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const deleteVolume = (project_uuid, id) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    await api.delete(`/volume/${id}`, {
      params: { project_uuid },
    });
    dispatch({
      type: DELETE_VOLUME,
      payload: id,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const createVolume = (project_uuid, values) => async (dispatch) => {
  try {
    if (!values.project_uuid) {
      if (!project_uuid) {
        throw new Error('project_uuid is required');
      }
      values.project_uuid = project_uuid;
    }
    const res = await api.post('/volume', values);
    if (project_uuid && res.data.project_uuid !== project_uuid) {
      return;
    }
    dispatch({
      type: CREATE_VOLUME,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const exportVolume = (project_uuid, id, values) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.post(`/volume/${id}/export`, values, {
      params: { project_uuid },
    });
    dispatch({
      type: UPDATE_VOLUME,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const abortExportVolume = (project_uuid, id) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.delete(`/volume/${id}/export`, {
      params: { project_uuid },
    });
    dispatch({
      type: UPDATE_VOLUME,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const fetchVolume = (project_uuid, id) => async (dispatch) => {
  try {
    const volume = await getVolume(project_uuid, id);
    if (!volume || _.isEmpty(volume)) {
      dispatch({ type: DELETE_VOLUME, payload: id });
    } else {
      dispatch({
        type: UPDATE_VOLUME,
        payload: volume,
      });
    }
  } catch (error) {
    dispatch(setErrorMessage(error));
    throw error;
  }
};

export const getVolume = async (project_uuid, id) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.get(`/volume/${id}`, {
      params: { project_uuid },
    });
    return res.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return;
    }
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};

export const getVolumeDetails = async (project_uuid, id) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.get(`/volume/${id}/details`, {
      params: { project_uuid },
    });
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};
